import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../utils/AuthContext';
import './Login.css';

const Login = () => {
  const [step, setStep] = useState('email'); // 'email' or 'otp'
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [devOtp, setDevOtp] = useState(''); // For development mode
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSendOTP = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.sendOTP(email);

      // Show dev OTP if in development mode
      if (response.data.devOtp) {
        setDevOtp(response.data.devOtp);
      }

      setStep('otp');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.verifyOTP(email, otp);

      // Store token and login
      login(response.data.token, email);

      // Redirect to dashboard
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleBackToEmail = () => {
    setStep('email');
    setOtp('');
    setError('');
    setDevOtp('');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>TRH Article Management</h1>
          <p>Manage and publish articles across multiple platforms</p>
        </div>

        {step === 'email' ? (
          <form onSubmit={handleSendOTP} className="login-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                disabled={loading}
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Sending...' : 'Send Login Code'}
            </button>

            <p className="login-note">
              You'll receive a 6-digit code via email. The code expires in 5 minutes.
            </p>
          </form>
        ) : (
          <form onSubmit={handleVerifyOTP} className="login-form">
            <div className="form-group">
              <label htmlFor="otp" className="form-label">
                Enter 6-Digit Code
              </label>
              <input
                type="text"
                id="otp"
                className="form-input otp-input"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                maxLength="6"
                required
                disabled={loading}
                autoFocus
              />
            </div>

            {devOtp && (
              <div className="dev-otp-message">
                <strong>Development Mode:</strong> Your OTP is <code>{devOtp}</code>
              </div>
            )}

            <p className="email-sent-message">
              Code sent to <strong>{email}</strong>
            </p>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Verifying...' : 'Verify & Login'}
            </button>

            <button
              type="button"
              className="btn btn-secondary btn-block"
              onClick={handleBackToEmail}
              disabled={loading}
            >
              Back to Email
            </button>
          </form>
        )}

        <div className="login-footer">
          <p>Proud user of Claude Code</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
